import { FC } from 'react';
import { withLogo, InnerLogoProps } from '@tempusfinance/common-ui';

const NostraSwapLogoComponent: FC<InnerLogoProps> = () => {
  return (
    <svg
      className="nostra__logo nostra__logo__nostraSwapLogo"
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="14"
      viewBox="0 0 78 14"
      fill="none"
    >
      <path
        d="M0.5 8.23403L6.47756 4.98308L0.5 1.73213V8.23403ZM7.9659 5.79187L0.5 9.85336L7.9659 13.9131L15.4318 9.85336V1.73213L7.9659 5.79362V5.79187ZM7.8709 0.34613L4.44717 2.26196L7.9659 4.17604L11.4828 2.26196L7.87276 0.347885L7.8709 0.34613Z"
        fill="#FF4240"
      />
      <path
        d="M26.2936 6.2988C25.8391 5.55493 25.1964 4.38297 24.768 3.53909H24.7419C24.781 4.47245 24.7959 5.63212 24.7959 6.42512V9.74099H23.3374V2.17766H25.5857L27.3255 5.13913C27.8751 6.07248 28.4898 7.20584 28.9182 8.03744H28.9312C28.9182 7.16724 28.9052 6.23564 28.9052 5.49177V2.17766H30.3637V9.73923H28.3706L26.2954 6.2988H26.2936Z"
        fill="#FF4240"
      />
      <path
        d="M39.3961 6.08476C39.3961 4.63561 38.4852 3.47593 36.7994 3.47593C35.1136 3.47593 34.2027 4.63561 34.2027 6.08476C34.2027 7.67252 35.0987 8.76903 36.7994 8.76903C38.5001 8.76903 39.3961 7.67252 39.3961 6.08476ZM32.6902 6.09704C32.6902 3.84085 34.2959 2.17766 36.7994 2.17766C39.3029 2.17766 40.9217 3.84085 40.9217 6.09704C40.9217 8.35324 39.383 10.0673 36.7994 10.0673C34.2158 10.0673 32.6902 8.36552 32.6902 6.09704Z"
        fill="#FF4240"
      />
      <path
        d="M43.0193 7.39532L44.4909 7.11812C44.7051 8.19007 45.4818 8.81991 46.7131 8.81991C47.7432 8.81991 48.2797 8.44096 48.2797 7.83743C48.2797 7.23391 47.8121 6.90408 46.2996 6.69004C44.0773 6.36196 43.3676 5.51808 43.3676 4.37069C43.3676 3.03382 44.4108 2.17766 46.3648 2.17766C48.479 2.17766 49.3359 3.24961 49.6432 4.63561L48.1437 4.92509C47.8904 3.92857 47.434 3.40049 46.2977 3.40049C45.4017 3.40049 44.9063 3.77769 44.9063 4.34613C44.9063 4.84965 45.2006 5.21632 46.9683 5.49352C49.2297 5.83388 49.8332 6.71636 49.8332 7.78831C49.8332 9.14974 48.8292 10.0691 46.6218 10.0691C44.1854 10.0568 43.2093 8.85851 43.0212 7.39707"
        fill="#FF4240"
      />
      <path d="M51.7461 2.17766H58.2229V3.53909H55.7473V9.74099H54.2217V3.53909H51.7461V2.17766Z" fill="#FF4240" />
      <path
        d="M62.0305 3.44962V5.46721H63.8504C64.7743 5.46721 65.2959 5.08825 65.2959 4.40753C65.2959 3.80226 64.9215 3.44962 63.9305 3.44962H62.0305ZM63.3679 6.73916H62.0305V9.73923H60.5049V2.17766H63.9975C65.8845 2.17766 66.7954 2.99697 66.7954 4.37069C66.7954 5.58124 66.1397 6.34968 64.9624 6.62688L67.3188 9.71467V9.73923H65.471L63.3698 6.73916H63.3679Z"
        fill="#FF4240"
      />
      <path
        d="M72.1637 6.69009H74.6653L74.317 5.80761C74.0227 5.0883 73.7153 4.30758 73.4601 3.58826H73.367C73.1118 4.30758 72.8045 5.0883 72.5101 5.80761L72.1618 6.69009H72.1637ZM75.1348 7.86204H71.6812L70.9324 9.73928H69.3528L72.5642 2.17595H74.304L77.5154 9.73928H75.8687L75.1329 7.86204H75.1348Z"
        fill="#FF4240"
      />
    </svg>
  );
};
export const NostraSwapLogo = withLogo(NostraSwapLogoComponent);
